<script>
	import Icon from '@/Components/Icon.svelte';
	export let text = '';
	export let className = '';
	export let onClick = undefined;
	export let formInput = false;
	export let formInputOnEdit = false;

	let original = text;
	let editing = false;

	function onSave() {
		text = text.trimEnd();
		editing = false;
		original = text;
		if (typeof onClick === 'function') onClick(text);
	}
	function onCancel() {
		text = original;
		editing = false;
	}
</script>

<div class="flex flex-shrink items-center {className}">
	<div
		class="cursor-pointer focus:outline-none {formInput ? 'form-input' : ''}"
		class:form-input={editing && formInputOnEdit}
		contenteditable="true"
		bind:textContent={text}
		on:focus={() => (editing = true)}
		on:keyup={(event) => {
			if (event.keyCode === 13) {
				onSave();
			}
		}}
	/>
	{#if editing}
		<button on:click={onSave}>
			<Icon name="tick-box" classes="w-3 h-3 ml-2" />
		</button>
		<button on:click={onCancel}>
			<Icon name="cross-box" classes="w-3 h-3 ml-1" />
		</button>
	{/if}
</div>
